import * as React from 'react';

const LogOut = (props) => (
  <svg fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.47 14.53a.75.75 0 0 1 0-1.06l1.293-1.293a.25.25 0 0 0 0-.354L17.47 10.53a.75.75 0 1 1 1.06-1.06l1.293 1.293a1.75 1.75 0 0 1 0 2.474L18.53 14.53a.75.75 0 0 1-1.06 0Z'
      fill='#333132'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.25 5.004a1.25 1.25 0 0 0-1.943-1.04l-2 1.333a1.25 1.25 0 0 0-.557 1.04v11.86c0 .417.209.808.557 1.04l2 1.333a1.25 1.25 0 0 0 1.943-1.04V5.004Zm1.459-.487c-.33-1.895-2.546-2.927-4.234-1.801l-2 1.333A2.75 2.75 0 0 0 3.25 6.337v11.86c0 .919.46 1.777 1.225 2.287l2 1.334c1.688 1.125 3.905.093 4.234-1.801H14a2.75 2.75 0 0 0 2.75-2.75.75.75 0 0 0-1.5 0c0 .69-.56 1.25-1.25 1.25h-3.25v-12.5H14c.69 0 1.25.56 1.25 1.25a.75.75 0 0 0 1.5 0A2.75 2.75 0 0 0 14 4.517h-3.291ZM12.25 12a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75Z'
      fill='#333132'
    />
  </svg>
);

export default LogOut;
